import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { dynamicSetup } from '@/mixins/dynamic-setup';

export default Vue.component('type-categories', {
  template: require('./template.html'),
  name: 'type-categories',
  mixins: [dynamicSetup],
  computed: {
    ...mapGetters([
      'currentSite',
      'activeSiteType',
    ]),
  },
  data() {
    return {
      categories: '',
      categoryList: false,
      catError: false,
      initialEdits: {
        categoryList: false,
      },
    };
  },
  props: ['item-modal', 'content', 'active-item', 'item-list', 'all-categories'],
  watch: {
    content(content) {
      if (content === 'categories') {
        this.setInitialValues();
      }
    },
  },
  methods: {
    setInitialValues() {
      this.categoryList = _.cloneDeep(this.allCategories);
      this.initialEdits.categoryList = _.cloneDeep(this.categoryList);
    },
    addCategory() {
      const array = this.categoryList;
      this.catError = false;
      if (this.categories.trim() === '') {
        return;
      }
      if (array.includes(this.categories)) {
        this.catError = 'That category already exists.';
        return;
      }
      this.categoryList.push(this.categories);
      this.categories = '';
    },
    removeCategory(index) {
      this.categoryList.splice(index, 1);
    },
    async saveCategories() {
      if (!this.noCategoryChanges()) {
        // only update if there was a change
        this.$emit('set-loading', true);
        const notif = {
          id: this.guid(),
          type: 'success',
          message: 'Changes Successfully Saved!',
        };
        try {
          if (this.noDynamicData(this.activeSiteType)) {
            this.dynamicSetup(this.activeSiteType);
          }
          this.$store.dispatch('setDropletVal', {
            drp: this.currentSite.dynamic[this.activeSiteType],
            key: 'categories',
            val: this.categoryList,
          });
          await this._SEND([{
            name: 'updateSiteAttr',
            payload: {
              siteId: this.currentSite._id,
              attr: 'dynamic',
              value: this.currentSite.dynamic,
            },
          }]);
          this.$log.debug('successfully updated item categories');
          this.initialEdits.categoryList = _.cloneDeep(this.categories);
          this.$emit('set-content', null);
        } catch (e) {
          this.$log.error('error: ', e);
          notif.type = 'error';
          notif.message = `${e.message || e}. This has been reported.`;
          await this._reportError({
            error: e,
            fn: 'items - saveCategories',
          });
        } finally {
          this.$emit('set-loading', false);
          this.$store.dispatch('addNotification', notif);
        }
      }
    },
    cancelChanges() {
      this.categoryList = _.cloneDeep(this.initialEdits.categoryList);
      this.$emit('set-content', null);
    },
    noCategoryChanges() {
      return _.isEqual(_.sortBy(this.categoryList), _.sortBy(this.initialEdits.categoryList));
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/categories/index.js